import * as fromDatatype from '../datatype-library/index';

export interface bl_aat_claim_item_travel_allowance_RowInterface {
  guid: fromDatatype.GuidDataFieldInterface;
  claim_item_hdr_guid: fromDatatype.GuidDataFieldInterface;
  destination: fromDatatype.VarcharDatatypeInterface;
  name: fromDatatype.VarcharDatatypeInterface;
  approval_workflow_type:fromDatatype.VarcharDatatypeInterface;
  breakfast_amount: fromDatatype.IntegerDatatypeInterface;
  lunch_amount: fromDatatype.IntegerDatatypeInterface;
  dinner_amount: fromDatatype.IntegerDatatypeInterface;
  inconvenience_amount: fromDatatype.IntegerDatatypeInterface;
  total_amount: fromDatatype.IntegerDatatypeInterface;
  descr: fromDatatype.VarcharDatatypeInterface;
  property_json: fromDatatype.JsonDatatypeInterface;
  namespace: fromDatatype.VarcharDatatypeInterface;
  applet_guid: fromDatatype.GuidDataFieldInterface;
  module_guid: fromDatatype.GuidDataFieldInterface;
  acl_config: fromDatatype.JsonDatatypeInterface;
  acl_policy: fromDatatype.JsonDatatypeInterface;
  created_date: fromDatatype.TimestampTzDatatypeInterface;
  updated_date: fromDatatype.TimestampTzDatatypeInterface;
  created_by_subject_guid: fromDatatype.GuidDataFieldInterface;
  updated_by_subject_guid: fromDatatype.GuidDataFieldInterface;
  status: fromDatatype.VarcharDatatypeInterface;
  revision: fromDatatype.GuidDataFieldInterface;
  vrsn: fromDatatype.VarcharDatatypeInterface;

}

export class bl_aat_claim_item_travel_allowance_RowClass implements bl_aat_claim_item_travel_allowance_RowInterface {
  guid: fromDatatype.GuidDataFieldInterface;
  claim_item_hdr_guid: fromDatatype.GuidDataFieldInterface;
  destination: fromDatatype.VarcharDatatypeInterface;
  name: fromDatatype.VarcharDatatypeInterface;
  approval_workflow_type:fromDatatype.VarcharDatatypeInterface;
  breakfast_amount: fromDatatype.IntegerDatatypeInterface;
  lunch_amount: fromDatatype.IntegerDatatypeInterface;
  dinner_amount: fromDatatype.IntegerDatatypeInterface;
  inconvenience_amount: fromDatatype.IntegerDatatypeInterface;
  total_amount: fromDatatype.IntegerDatatypeInterface;
  descr: fromDatatype.VarcharDatatypeInterface;
  property_json: fromDatatype.JsonDatatypeInterface;
  namespace: fromDatatype.VarcharDatatypeInterface;
  applet_guid: fromDatatype.GuidDataFieldInterface;
  module_guid: fromDatatype.GuidDataFieldInterface;
  acl_config: fromDatatype.JsonDatatypeInterface;
  acl_policy: fromDatatype.JsonDatatypeInterface;
  created_date: fromDatatype.TimestampTzDatatypeInterface;
  updated_date: fromDatatype.TimestampTzDatatypeInterface;
  created_by_subject_guid: fromDatatype.GuidDataFieldInterface;
  updated_by_subject_guid: fromDatatype.GuidDataFieldInterface;
  status: fromDatatype.VarcharDatatypeInterface;
  revision: fromDatatype.GuidDataFieldInterface;
  vrsn: fromDatatype.VarcharDatatypeInterface;
}
